<template>
  <div class="e4s-flex-column e4s-flex-grow e4s-gap--small" :class="getCss">
    <div class="e4s-flex-row e4s-justify-flex-space-between-xxx">
      <div class="e4s-flex-column e4s-gap--small">
        <div class="e4s-flex-row e4s-justify-flex-row-vert-center">
          <!--          <div class="e4s-flex-column e4s-gap&#45;&#45;small results-schedule-comp-event&#45;&#45;type-no">-->
          <!--            <div v-text="getEventTime" class="e4s-subheader&#45;&#45;general-qazz"></div>-->
          <!--            <div v-text="compEvent.typeNo + ':'"></div>-->
          <!--          </div>-->
          <div class="e4s-flex-row results-schedule-comp-event--type-no">
            <div
              v-text="getEventTime"
              :style="hasResults ? 'font-weight: bold;' : ''"
              class="e4s-lite-number"
            ></div>
          </div>

          <div class="e4s-flex-row e4s-gap--small e4s-justify-flex-row-vert-center">
            <div
              v-text="compEvent.typeNo + ': ' + compEvent.name"
              :style="hasResults ? 'font-weight: bold;' : ''"
            ></div>
            <div class="e4s-flex-row e4s-gap--small">
              <span v-text="getEventText" class="e4s-subheader--general"></span>
            </div>
          </div>
        </div>
      </div>

      <div class="e4s-flex-column e4s-gap--small e4s-flex-row--end">
        <InputCheckboxObject
          v-if="showFollowEventSetup"
          :value="!!isFollowing"
          value-label="Follow"
          @input="shouldFollowEvent"
        />
        <div
          v-if="!showFollowEventSetup"
          class="e4s-flex-column e4s-gap--standard e4s-flex-row--end"
        >
          <div
            class="e4s-flex-row e4s-gap--standard e4s-flex-row--end e4s-justify-flex-row-vert-center"
          >
            <!--            <PrimaryLink-->
            <!--              :link-text="'View ' + (hasResults ? 'Results' : 'Details')"-->
            <!--              @click="showDetails"-->
            <!--            />-->

            <PulseIndicator
              v-if="getIsFollowing"
              color="var(--socket-active-color)"
              :animate="true"
            />
            <ButtonGenericV2
              class="e4s-button--slim"
              :button-type="hasResults ? 'primary' : 'secondary'"
              :text="'View ' + (hasResults ? 'Results' : 'Details')"
              @click="showDetails"
            />

            <!--            :class="hasResults ? 'results-schedule-comp-event&#45;&#45;has-results-link' : ''"-->
          </div>

          <div
            class="e4s-flex-row e4s-gap--small e4s-flex-row--end e4s-justify-flex-row-vert-center"
          >
            <!-- <PulseIndicator
              v-if="getIsFollowing"
              color="var(--socket-active-color)"
              :animate="true"
            /> -->
            <span v-if="hasWaitlist && !isWaitListClosed" class="waitlist-badge">
              Waitlist: {{ waitlistCount }}
            </span>
            <div v-text="entryCountText"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed, type PropType } from 'vue'
import type {
  CompEvent,
  ShouldFollowEvent,
  StoreCompResultsState
} from '@/components/results/store-comp-results'
import * as ResultsService from '@/components/results/results-service'
import ButtonGenericV2 from '@/common/ui/buttons/button-generic-v2.vue'
import type { IBaseConcrete } from '@/common/common-models'
import TickIcon from '@/common/ui/svg/TickIcon.vue'
import InputCheckboxObject from '@/common/ui/fields/InputCheckboxObject.vue'
import PrimaryLink from '@/common/ui/href/PrimaryLink.vue'
import PulseIndicator from '@/common/ui/icons/PulseIndicator.vue'
import { isWaitingListCloseed } from '@/components/results/results-service'

const props = defineProps({
  storeCompResultsState: {
    type: Object as PropType<StoreCompResultsState>,
    required: true
  },
  compEvent: {
    type: Object as PropType<CompEvent>,
    required: true
  },
  isFollowing: {
    type: Object as PropType<IBaseConcrete | undefined>,
    required: false,
    default: () => undefined
  },
  showFollowEventSetup: {
    type: Boolean,
    default: false
  }
})

//  console.log('ResultsScheduleCompEvent props >> > > >>>> >> >>> > >:', props)

//  define emits.
const emit = defineEmits<{
  (e: 'showDetails', value: CompEvent): void
  (e: 'shouldFollowEvent', value: ShouldFollowEvent): void
}>()

/**
 * Safely resolve egOptions from the compEvent.
 * The API returns egOptions as a JSON string, which the converter service
 * normally parses into an object. But on soft navigation (e.g., linking from
 * the primary application) the parsing can be bypassed and egOptions arrives
 * as a raw string. This helper normalises the value so downstream computed
 * properties always receive an object.
 */
function resolveEgOptions() {
  const raw = props.compEvent.egOptions
  if (typeof raw === 'string') {
    try {
      return JSON.parse(raw) as Record<string, unknown>
    } catch {
      return {}
    }
  }
  return (raw ?? {}) as unknown as Record<string, unknown>
}

const whatIsEgGoptionsType = computed(() => {
  console.log(
    'typeof props.compEvent.egOptions for egId ' +
      props.compEvent.egId +
      '-' +
      props.compEvent.egOptions +
      ':' +
      typeof props.compEvent.egOptions
  )

  return typeof props.compEvent.egOptions
})

const isTeam = computed(() => {
  return ResultsService.isTeamEvent(props.compEvent)
})

const isScheduleOnly = computed(() => {
  const maxAthletes = resolveEgOptions().maxathletes as number | undefined
  return maxAthletes === -1
})

const getEventTime = computed(() => {
  return ResultsService.getCompEventStartTime(props.compEvent)
})

const entryCountText = computed(() => {
  // <div v-text="(isTeam ? 'Teams' : 'Entries') + ':'"></div>

  if (isTeam.value) {
    return 'Teams: ' + String(ResultsService.howManyTeams(props.compEvent))
  }
  const count = ResultsService.compEventHasHowManyEntries(props.compEvent)
  const maxAthletes = resolveEgOptions().maxathletes as number | undefined

  if (maxAthletes === -1) {
    return 'Scehedule Only'
  }

  if (!maxAthletes || maxAthletes <= 0) return 'Entries: ' + String(count)
  return `Entries: ${count} / ${maxAthletes}`
})

const waitlistCount = computed(() => {
  if (isTeam.value) {
    // console.log('[waitlistCount] isTeam=true, egId:', props.compEvent.egId)
    return 0
  }
  const egOptions = resolveEgOptions()
  const maxAthletes = egOptions.maxathletes as number | undefined
  const count = ResultsService.compEventHasHowManyEntries(props.compEvent)
  // console.log(
  //   '[waitlistCount] egId:',
  //   props.compEvent.egId,
  //   'maxAthletes:',
  //   maxAthletes,
  //   'entryCount:',
  //   count,
  //   'egOptions type:',
  //   typeof props.compEvent.egOptions,
  //   'egOptions:',
  //   egOptions
  // )
  if (!maxAthletes || maxAthletes <= 0) {
    // console.log('[waitlistCount] returning 0 due to maxAthletes <= 0')
    return 0
  }
  const result = Math.max(0, count - maxAthletes)
  // console.log('[waitlistCount] result:', result)
  return result
})

const hasWaitlist = computed(() => {
  return waitlistCount.value > 0
})

const isWaitListClosed = computed(() => {
  const isWaitClosed = isWaitingListCloseed(props.storeCompResultsState.competitionOnTheDay.options)
  return isWaitClosed
})

const resultCount = computed(() => {
  return ResultsService.compEventHasHowManyResultHeats(props.compEvent)
})

const getEventText = computed(() => {
  return props.compEvent.eventText ? props.compEvent.eventText : ''
})

const hasResults = computed(() => {
  return resultCount.value > 0
  // return entryCount.value > 0
})

function showDetails() {
  emit('showDetails', props.compEvent)
}

function shouldFollowEvent() {
  const currentlyFollowing = props.isFollowing
  emit('shouldFollowEvent', {
    isFollowing: !currentlyFollowing,
    compEvent: props.compEvent
  })
}

const getIsFollowing = computed(() => {
  return props.isFollowing
})

const getCss = computed(() => {
  const css = []

  if (resultCount.value > 0) {
    css.push('results-schedule-comp-event--has-results')
  }

  if (props.isFollowing) {
    css.push('results-schedule-comp-event--is-following')
  }

  return css
})
</script>

<style scoped>
.results-schedule-comp-event--event-time {
  width: 50px;
}
.results-schedule-comp-event--type-no {
  width: 50px;
}

.results-schedule-comp-event--has-results-x {
  background: var(--green-200);
}

.results-schedule-comp-event--has-results-link {
  color: var(--green-700);
}

.results-schedule-comp-event--is-following-x {
  background: var(--green-100);
  border-left: 3px solid var(--green-500);
}

.waitlist-badge {
  display: inline-block;
  padding: 2px 8px;
  background-color: var(--amber-100, #fef3c7);
  color: var(--amber-800, #92400e);
  border-radius: 4px;
  font-size: 0.75rem;
  font-weight: 600;
  line-height: 1;
  white-space: nowrap;
}
</style>
